import { ModulesService } from "@/common/api.service"
import { FETCH_MODULES, FETCH_QUIZ_DETAILS,FETCH_QUIZ_DATA,FETCH_MODULE_PLAYER, SAVE_USER_SLIDE_ID, FETCH_INDIVIDUAL_MODULE,RESET_STATE } from "./actions.type"
import { SET_MODULES, SET_QUIZ_DETAILS,SET_QUIZ_DATA,SET_ERROR,SET_INDIVIDUAL_MODULE, STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
    modules: [],
    quizdata:[],
    individualModule: [],
    quizdetails: [],
    moduleerrors:[],
    }
}

let state = initialState()

const getters = {
    modules(state) {
        return state.modules
    },
    individualmodule(state) {
        return state.individualModule
    },
    quizdata(state) {
        return state.quizdata
    },
    quizdetails(state) {
        return state.quizdetails
    }    
};

const actions = {
    async [FETCH_MODULES](context, moduleSlug) {
        const { data } = await ModulesService.get(moduleSlug)
        context.commit(SET_MODULES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_MODULE](context, moduleid) {
        const { data } = await ModulesService.get(moduleid)
        context.commit(SET_INDIVIDUAL_MODULE, data.data)
        return data;        
    },
    async [SAVE_USER_SLIDE_ID]  (context,data){
        return ModulesService.slide(data)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR, error.response.data.errors)
        });
    },
    async [FETCH_QUIZ_DATA] (context) {
        let modulequizdata=[]
        context.state.modules.forEach(function (moduledata){
            if(moduledata.hasOwnProperty('quiz_data') && moduledata.quiz_data.length > 0){
              moduledata.quiz_data.forEach(function (quizdata){
                modulequizdata.push({title: quizdata.title, stored_at: quizdata.stored_at ,id: quizdata.id, statement_query: quizdata.statement_query, yourscore: quizdata.result.score.raw,  maxscore: quizdata.result.score.max, seconds: (quizdata.result.hasOwnProperty('seconds')?quizdata.result.seconds : '')})
              })
            }
            
          })        
        context.commit(SET_QUIZ_DATA, modulequizdata)
    },
    [FETCH_QUIZ_DETAILS](context, id) {
        const quiz_details = context.state.quizdata.filter(data =>data.id == id)
        context.commit(SET_QUIZ_DETAILS, quiz_details)
    },
    async [FETCH_MODULE_PLAYER](context, moduleid) {
        const { data } = await ModulesService.courseplayer(moduleid)
        context.commit(SET_INDIVIDUAL_MODULE, data.data)
        return data      
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET)
    }
};

const mutations = {
    [SET_MODULES](state, modules) {
        state.modules = modules
    },
    [SET_INDIVIDUAL_MODULE](state, module) {
        state.individualModule = module
    },
    [SET_ERROR](state, error) {
        state.moduleerrors = error;
    },     
    [SET_QUIZ_DATA] (state, quizdata) {
        state.quizdata = quizdata
    },
    [SET_QUIZ_DETAILS] (state, quizdetailsdata){
        state.quizdetails   =   quizdetailsdata
    },
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};